import React from 'react'

import Input from '../ui/input'
import FieldLabel from '../ui/input/FieldLabel'
import StaticCurrencySelector from './staticCurrencySelector'
import { DEFAULT_CURRENCY_CODE, getStaticCurrencyByCode } from '../../lib/currencies'
import { TBusiness } from '../../types'

type Props = {
  businessDetails: TBusiness
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  showErrors?: boolean
  flashNonce?: number
}

const GuestInlineBusinessFields: React.FC<Props> = ({
  businessDetails,
  onChange,
  showErrors = false,
  flashNonce = 0,
}) => {
  const missingName = !businessDetails.name?.trim()
  const currencyCode = businessDetails.currency?.code?.trim()
  const missingCurrency = !currencyCode || !getStaticCurrencyByCode(currencyCode)

  return (
    <div
      key={flashNonce}
      data-invoice-field='business'
      className={`invoice-prereq-box position-relative ${showErrors ? ' invoice-prereq-box--error invoice-prereq-box--flash' : ''}`}
    >
      <div className='mb-3'>
        <FieldLabel label='Your Business Name' htmlFor='guestBusiness.name' required />
        <input
          className={`form-control form-control-md${showErrors && missingName ? ' is-invalid' : ''}`}
          id='guestBusiness.name'
          name='businessDetails.name'
          placeholder='Acme Ltd.'
          value={businessDetails.name || ''}
          onChange={onChange}
          required
        />
      </div>
      <div className='mb-3'>
        <Input
          label='Billing Address'
          id='guestBusiness.billingAddress'
          name='businessDetails.billingAddress'
          placeholder='123 Main Street'
          value={businessDetails.billingAddress || ''}
          onChange={onChange}
          optional
        />
      </div>
      <div className='mb-3'>
        <StaticCurrencySelector
          key={currencyCode || DEFAULT_CURRENCY_CODE}
          value={currencyCode || DEFAULT_CURRENCY_CODE}
          onChange={onChange}
          label='Currency'
        />
        {showErrors && missingCurrency && (
          <small className='text-danger'>Required</small>
        )}
      </div>
      {showErrors && missingName && (
        <small className='text-danger position-absolute start-50 translate-middle-x bottom-0 pb-2'>
          Required
        </small>
      )}
    </div>
  )
}

export default GuestInlineBusinessFields
